export enum EmployeeType {
  PERMANENT = 'PERMANENT',
  FREELANCER = 'FREELANCER',
  EXTERNAL = 'EXTERNAL',
  TEMPORARY = 'TEMPORARY'
}
